export type GasStepsType = 'base' | 'active' | 'warning' | 'success';

export enum GasStepsState {
  Base = 'base',
  Active = 'active',
  Warning = 'warning',
  Success = 'success',
};
